import { defaultTo } from 'ramda';
import { ICloudpaymentsStartWidgetPaymentResponse } from '../../../../repositories/billing-accounts/v1/cloudpayments/start-widget-payment';
import { mapData } from './mapData';
import { ICloudPaymentsPaymentOptions } from '../../../../types/cloudPayments';

interface IParams {
  response: ICloudpaymentsStartWidgetPaymentResponse;
  amount: number;
}

export const mapPaymentOptions = (params: IParams): ICloudPaymentsPaymentOptions => {
  const {
    response: { publicId, transactionId, description, data },
    amount,
  } = params;

  return {
    publicId: defaultTo('', publicId),
    invoiceId: defaultTo('', transactionId),
    description: defaultTo('', description),
    data: mapData(data),
    amount,
    currency: 'RUB' as const,
    skin: 'mini' as const,
  };
};
